/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, EventEmitter, Input, Output, QueryList, ViewChildren} from "@angular/core";
import {PatterComponent} from "./patter/patter.component";
import {FloatingComponent} from "../floating/floating.component";

/*
* */
@Component({
	selector: "aigia-patter-table",
	templateUrl: "./patter-table.component.html",
	styleUrls: ["../floating/floating.component.css", "./patter-table.component.css"],
})
export class PatterTableComponent extends FloatingComponent {

	@Input() public locked: boolean;
	@Input() public endpoint: string;
	@Input() public shots: any[];
	@Input() public patters: any[];
	@Input() public size: number[];

	@Input() public rigid: boolean = false;
	@Input() public camera: number[] = [1];

	@Output() public progrssChange = new EventEmitter<boolean>();

	@ViewChildren(PatterComponent) public PatterComponents: QueryList<PatterComponent>;

	public title: string = "Image";

	public hasprev: boolean = true;
	public hasnext: boolean = true;

	/**
	 * @returns none
	 */
	public first(camera: number): void {
		let hasprev = true;
		let hasnext = true;
		this.PatterComponents.forEach((patter) => {
			patter.first(camera);
			hasprev = hasprev && patter.hasprev;
			hasnext = hasnext && patter.hasnext;
		});
		this.hasprev = hasprev;
		this.hasnext = hasnext;
	}

	/**
	 * @returns none
	 */
	public last(camera: number): void {
		let hasprev = true;
		let hasnext = true;
		this.PatterComponents.forEach((patter) => {
			patter.last(camera);
			hasprev = hasprev && patter.hasprev;
			hasnext = hasnext && patter.hasnext;
		});
		this.hasprev = hasprev;
		this.hasnext = hasnext;
	}

	/**
	 * @returns none
	 */
	public next(camera: number): void {
		let hasprev = true;
		let hasnext = true;
		this.PatterComponents.forEach((patter) => {
			patter.next(camera);
			hasprev = hasprev && patter.hasprev;
			hasnext = hasnext && patter.hasnext;
		});
		this.hasprev = hasprev;
		this.hasnext = hasnext;
	}

	/**
	 * @returns none
	 */
	public prev(camera: number): void {
		let hasprev = true;
		let hasnext = true;
		this.PatterComponents.forEach((patter) => {
			patter.prev(camera);
			hasprev = hasprev && patter.hasprev;
			hasnext = hasnext && patter.hasnext;
		});
		this.hasprev = hasprev;
		this.hasnext = hasnext;
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}
